import { RowClassParams } from 'ag-grid-enterprise'
import { EnhancedStatementRow } from '../../../utils/dataEnhancement'
import { getRowTypeClassName } from '../../../utils/columnUtils'

// Re-export shared AG Grid configurations
export {
  getCellSelectionConfig,
  getStatusBarConfig,
  getColumnsSideBarConfig
} from '../../../../../shared/utils/agGridConfig'

/**
 * Get CSS classes for a row based on its type
 */
export const getRowClass = (params: RowClassParams<EnhancedStatementRow>): string[] => {
  const row = params.data as EnhancedStatementRow
  const classes: string[] = []

  if (!row) return classes

  const className = getRowTypeClassName(row.rowType)
  if (className) {
    classes.push(className)
  }

  return classes
}
